import alt from '../../alt';
import si from 'si';
import PartyDetails from './PartyDetails';
import MessageActions from '../../Message/MessageActions';


class HostPortalActions {
    constructor() {}

    addGuest(data) {
        si.addEventGuest(data).then(this.addGuestSuccess, this.addGuestFailure);
        return true;
    }

    getTimeZones() {
        si.getTimeZones().then(this.getTimeZonesSuccess, this.getTimeZonesFailure);
        return true;
    }

    getTimeZonesSuccess(data) {
        return data;
    }

    getTimeZonesFailure(data) {
        return data;
    }

    getHostPartyList() {
        si.getHostEvents().then(this.getHostEventSuccess, this.getHostEventFailure);
        return true;
    }

    getEventDetails(eventCode) {
        si.getEventDetails(eventCode).then(this.getEventSuccess, this.getEventFailure);
        return true;
    }

    getHostEventDetails(eventCode) {
        si.getHostEventDetails(eventCode).then(this.getHostEventDetailSuccess, this.getHostEventDetailFailure);
        return true;
    }

    getEventTypes() {
        si.getEventTypes().then(this.eventTypesSuccess, this.eventTypesFailure);
        return true;
    }

    getGuestStatuses() {
        si.getGuestStatuses().then(this.getGuestStatusesSuccess, this.getGuestStatusesFailure);
        return true;
    }

    validateGuest(GuestInfo) {
        si.validateGuest(GuestInfo).then((data) => {
            if (data) this.addGuest(GuestInfo);
            this.validateGuestSuccess(data);
        }, this.validateGuestFailure);
        return true;
    }
    validateGuestEdit(GuestInfo) {
        si.validateGuest(GuestInfo).then(this.validateGuestEditSuccess, this.validateGuestEditFailure);
        return true;
    }

    updateGuest(guestData) {
        si.updateGuest(guestData).then(this.updateGuestSuccess, this.updateGuestFailure);
        return true;
    }

    updateGuestSuccess(data) {
        return data;
    }

    updateGuestFailure(data) {
        return data;
    }

    deleteGuest(guestData) {
        si.deleteGuest(guestData).then(this.deleteGuestSuccess, this.deleteGuestFailure);
        return true;
    }

    deleteGuestSuccess(data) {
        return data;
    }

    deleteGuestFailure(data) {
        return data;
    }

    setSelectedStatus(status) {
        return status;
    }

    setSelectedParty(party) {
        return party;
    }

    resetValidGuestEmail() {
        return true;
    }

    resetValidGuestEmailEdit() {
        return true;
    }

    validateGuestSuccess(data) {
        return data;
    }

    validateGuestFailure(data) {
        return data;
    }

    validateGuestEditSuccess(data) {
        return data;
    }

    validateGuestEditFailure(data) {
        return data;
    }

    getGuestStatusesSuccess(data) {
        return data;
    }

    getGuestStatusesFailure(data) {
        return data;
    }

    getHostEventSuccess(data) {
        return data;
    }

    getHostEventFailure(data) {
        return data;
    }

    getEventSuccess(data) {
        return data;
    }

    getEventFailure(data) {
        return data;
    }

    getHostEventDetailSuccess(data) {
        return data;
    }

    getHostEventDetailFailure(data) {
        return data;
    }

    getHostEventFailure(data) {
        return data;
    }

    partyCreatedTab() {
        return true;
    }

    getTemplateResource(templateResourceId, intercept) {
        var self = this;
        si.getTemplateResource(templateResourceId).then(function (resource) {
            if (intercept && typeof intercept === "function") {
                resource = intercept(resource);
            }
            self.getTemplateResourceSuccess(resource);
        }, self.getTemplateResourceFailure);
        return true;
    }

    getTemplateResourceSuccess(resourceData) {
        return resourceData[0].value;
    }

    getTemplateResourceFailure(data) {
        return data;
    }

    savePartyDetailsChanges(eventData) {
        si.saveEventChanges(eventData).then(this.savePartyChangesSuccess, this.savePartyChangesFailure);
        return true;
    }

    savePartyChangesSuccess(data) {
        return data;
    }

    savePartyChangesFailure(data) {
        return data;
    }

    sendAllPendingInvites(eventCode) {
        si.sendAllPendingInvites(eventCode).then(this.sendPendingInvitesSuccess, this.sendPendingInvitesFailure);
        return true;
    }

    sendPendingInvitesSuccess(data) {
        return data;
    }

    sendPendingInvitesFailure(data) {
        return data;
    }

    sendReminder(eventGuest) {
        si.sendReminder(eventGuest).then(this.sendReminderSuccess, this.sendReminderFailure);
        return true;
    }

    sendReminderSuccess(data) {
        return data;
    }

    sendReminderFailure(data) {
        return data;
    }

    sendAllReminders(eventCode) {
        si.sendAllReminders(eventCode).then(this.sendRemindersSuccess, this.sendRemindersFailure);
        return true;
    }

    sendRemindersSuccess(data) {
        return data;
    }

    sendRemindersFailure(data) {
        return data;
    }

    sendGuestInvite(eventCode, guestCode, isResend) {
        si.sendGuestInvite(eventCode, guestCode).then((data) => {
            this.sendGuestInviteSuccess(data, isResend);
        }, this.sendGuestInviteFailure);
        return true;
    }

    sendGuestInviteSuccess(data, isResend) {
        return { eventData: data, isResend: isResend };
    }

    sendGuestInviteFailure(data) {
        return data;
    }

    setNewInviteStyle(eventCode, templateId) {
        si.setNewInviteTemplate(eventCode, templateId).then(this.setNewInviteTemplateSuccess, this.setNewInviteTemplateFailure);
        return true;
    }

    setNewInviteTemplateSuccess(data) {
        return data;
    }

    setNewInviteTemplateFailure(data) {
        return data;
    }

    setNewPartyAddress(address) {
        return address;
    }

    setPartyVisibility(isPublic, eventCode) {
        si.setPartyVisibility(isPublic, eventCode).then(this.setPartyVisibilitySuccess, this.setPartyVisibilityFailure);
        return true;
    }

    setPartyVisibilitySuccess(data) {
        return data;
    }

    setPartyVisibilityFailure(data) {
        return data;
    }

    requestPhysicalParty(physicalData) {
        si.requestPhysicalParty(physicalData).then(this.physicalEventSuccess, this.physicalEventFailure);
        return true;
    }

    physicalEventSuccess(response) {
        if (response) {
            return response;
        }
        MessageActions.addErrorMessage(window.jenkon.resources["PWS.MyAccount.RequestPhysicalPartyFailed"]);
        return true;
    }

    physicalEventFailure(data) {
        return data;
    }

    resetSuccessState() {
        return true;
    }

    createVirtualEvent(virtualEventData, setView) {
        si.createVirtualEvent(virtualEventData).then((eventCode) => {
            if (eventCode != null) {
                setView(PartyDetails, eventCode);
                this.partyCreatedTab();
            }
        }, this.createVirtualEventFailure);
        return true;
    }

    createVirtualEventSuccess(data) {
        return data;
    }

    createVirtualEventFailure(data) {
        return data;
    }

    clearFormValues() {
        return true;
    }

    changeField(name, value) {
        var diff = {};
        diff[name] = value;
        return diff;
    }

    changeTheme(name, value) {
        var diff = {};
        diff[name] = value;
        return diff;
    }

    addGuestSuccess(data) {
        return data;
    }

    addGuestFailure(data) {
        return data;
    }

    setVirtual(isVirtual) {
        return isVirtual;
    }

    eventTypesSuccess(data) {
        return data;
    }

    eventTypesFailure(data) {
        return [];
    }

    setTab(tab) {
        return tab;
    }

    sendCartPaymentLink(eventCode, cartCode) {
        si.sendCartPaymentLink(eventCode, cartCode).then(this.sendCartPaymentLinkSuccess, this.sendCartPaymentLinkFailure);
        return true;
    }
    sendCartPaymentLinkSuccess(data) {
        return data;
    }
    sendCartPaymentLinkFailure(data) {
        return data;
    }
}

export default alt.createActions(HostPortalActions);



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/MyAccount/HostPortal/HostPortalActions.js